module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS11.009f1116.jpg";